<template>
  <div>
    <form data-vv-scope="Category" class="">
      <vs-input
        label="Category Name"
        class="mb-4 w-full requiredInput"
        v-model="category_name"
        v-validate="'required'"
        data-vv-name="Category Name"
      />
      <div
        v-if="errors.has('Category.Category Name')"
        style="color: red"
        class="invalid-feedback"
      >
        {{ errors.first("Category.Category Name") }}
      </div>
      <div class="flex mt-5 justify-end">
        <vs-button
          color="primary"
          type="filled"
          style="font-size: 13.8px; padding: 9px"
          class="mr-3"
          @click="creatingAssetCategory()"
        >
          Create Category
        </vs-button>
      </div>
    </form>
  </div>
</template>

<script>
import { createAssetsCategoryApi } from '@/api/room.js'

export default {
  data () {
    return {
      category_name: ''
    }
  },
  methods: {
    creatingAssetCategory () {
      this.$validator.validateAll('Category').then((valid) => {
        if (valid) {
          const customer_id = this.$store.getters.customerId
          const payload = {
            category_name: this.category_name,
            customer_id
          }
          this.creatingCategory(payload)
        } else {
          this.showSuccessMessage(
            'Warning',
            'Mandatory Field is Requiered',
            'danger'
          )
        }
      })
     
    },
    async creatingCategory (payload) {
      try {
        this.$vs.loading({
          text:'Creating New Category List'
        })
        const responseCategory = await createAssetsCategoryApi(payload)
        this.showSuccessMessage(
          'Success',
          'New Assets  Created successfully',
          'success'
        )        
        this.$emit('gettingNewCategory', responseCategory.data.data.assets_category_details)
        // 
      } catch (error) {
        
      } finally {
        this.$vs.loading.close()

      }
    }
    
  }
}
</script>

<style lang="scss" scoped>
</style>